import { useCallback, useEffect } from 'react'
import { useCopyToClipboard } from 'react-use'

import CopyIcon from '@/assets/icons/copy.svg?react'
import { message } from '@/components'
import { cn } from '@/utils/style'

interface CopyProps {
  text: string
  size: 'md' | 'lg' | 'xl'
  onlyIcon?: boolean
  copiedMsg?: string
}

export function Copy({ text, size, onlyIcon, copiedMsg = 'Copied' }: CopyProps) {
  const [state, copyToClipboard] = useCopyToClipboard()

  const handleCopy = useCallback(() => {
    copyToClipboard(text)
  }, [copyToClipboard, text])

  useEffect(() => {
    if (state.value) {
      message.success(copiedMsg)
    }
  }, [state])

  const sizeMap = {
    md: 16,
    lg: 20,
    xl: 24,
  }

  const textSizeMap = {
    md: 't-xs',
    lg: 't-sb',
    xl: 't-sm',
  }

  const iconSize = sizeMap[size]
  const textSizeClass = textSizeMap[size]

  return (
    <div
      className={cn(
        'cursor-pointer flex space-x-0.5 items-center',
        textSizeClass,
        'text-highlight',
      )}
      onClick={handleCopy}
    >
      <div>
        <CopyIcon width={iconSize} height={iconSize} />
      </div>
      {!onlyIcon && <div>Copy</div>}
    </div>
  )
}
